import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';

import NumberDataPod from '../../../components/NumberDataPod';

const TotalUndergraduateEnrollment = ({ studentLife }) => {
  const value = get(studentLife, 'schoolSize.undergraduateTotal.value');
  const lastUpdated = get(studentLife, 'lastUpdated.value');

  return (
    !Number.isNaN(+value) &&
    +value > 0 && (
      <NumberDataPod
        header={`Total Undergraduate Enrollment`}
        footer={lastUpdated}
        ariaLabel={`Total Undergraduate Enrollment, ${value}`}
        content={{
          value: +value,
          linkText: `Learn more about the students who attend`,
          linkUrl: 'Student_Life#student-body',
        }}
      />
    )
  );
};
TotalUndergraduateEnrollment.propTypes = {
  studentLife: PropTypes.object,
};

export default TotalUndergraduateEnrollment;
